import { Component, OnInit, ViewChild, } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { DatePipe } from '@angular/common';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { saveAgencyQrCodeBO } from '../claims.model';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
    selector: 'app-qr-barcode-invoice',
    templateUrl: './qr-barcode-invoice.component.html',
    styleUrls: ['./qr-barcode-invoice.component.scss']
})
export class QrBarCodeComponent implements OnInit {
    private onDestroy$: Subject<void> = new Subject<void>();
    DeleteQRId: any;
    QRList: any = [];
    fileName: string = "";
    QRType: string;
    HsFile: File = null;
    validatingFile: boolean = false;
    saveQR: saveAgencyQrCodeBO = new saveAgencyQrCodeBO();
    @ViewChild('gridQR') public gridQR: GridComponent;
    public initialPage: PageSettingsModel;
    constructor( public CommonAPI: CommonApiService, public datepipe: DatePipe, public toastrService: ToastrService,
        
        public global: GlobalComponent,) {
    }
    ngOnInit(): void {
        this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };

        this.getQRList();
    }
    //..............................................onFileUpload......................................................
    onFileUpload(fileInput: any) {
        if (fileInput.target.files.length > 0) {
            this.HsFile = fileInput.target.files[0];
            this.fileName = this.HsFile.name;
            this.QRType = this.HsFile.type;
            if (this.QRType == "image/png" || this.QRType == "image/gif" || this.QRType == "image/jpeg") {
                this.validatingFile = false;
            }
            else {
                this.validatingFile = true;
            }
        }

    }
    //.....................................................getQRList..............................................
    getQRList() {
        let url = "api/AgencyQrCode/GetQrcodeList?";
        this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
            this.QRList = data;
            if (data != null && data.length >= 15) {
                this.gridQR.height = "500";
            } else {
                this.gridQR.height = "auto";
            }
        }, err => {
        })
    }


    //..............................................tobase64......................................................
    tobase64 = value => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(value);
        reader.onload = (e: any) => resolve(e.target.result);
        reader.onerror = error => reject(error);
    });
    //....................................................SaveOrUpdateQR.................................................
    async SaveOrUpdateQR() {
        let url = "api/AgencyQrCode/SaveQrCode";
        let saveQRInfo: saveAgencyQrCodeBO = JSON.parse(JSON.stringify(this.saveQR));
        saveQRInfo.id = this.saveQR.id;
        let basevalue: any;
        basevalue = await this.tobase64(this.HsFile);
        saveQRInfo.qrImage = basevalue;
        this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveQRInfo,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
            if (this.saveQR.id == "00000000-0000-0000-0000-000000000000") {
                this.toastrService.success('Payment QR Code saved successfully');
                setTimeout(() => {
                    this.toastrService.clear();
                }, 8000);
            }
            
            this.openDialog();
            this.getQRList();

        }, (err: any) => {
            if (err) {
                this.toastrService.error(err, 'Error'), 8000;
            }
        })
    }
    //..........................................getDetails.............................................................
    getDetails(list) {
        var a = document.createElement("a"); //Create <a>
        a.href = list.qrImage; //Image Base64 Goes here
        a.download = "QR.png"; //File name Here
        a.click(); //Downloaded file
    }
    //.....................................................setQRId..............................................
    setQRId(data) {
        this.DeleteQRId = data.id;
    }
    GetQrcodeImage(data) {
        let url = "api/AgencyQrCode/GetQrcodeImage?";
        let params = new URLSearchParams();
        params.append("Id", data.id);
        this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
            this.getDetails(data);
        }, err => {
        })
    }
    //.....................................................DeleteQRDetails..............................................
    DeleteQRDetails() {
        let params = new URLSearchParams();
        params.append("Id", this.DeleteQRId);
        let url = "api/AgencyQrCode/DeleteAgencyQrcode?";
        this.CommonAPI.DeleteFunctionForDeleteHttp(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
            this.toastrService.success('Payment QR Code Deleted successfully!');
            document.getElementById('openDelete').click()
            this.getQRList();
            setTimeout(() => {
                this.toastrService.clear();
            }, 8000);
        },
            (err: any) => {
                this.toastrService.error(err);
                setTimeout(() => {
                    this.toastrService.clear();
                }, 8000);
            })
    }

    //...................................................openDialog................................................
    openDialog() {
        this.saveQR = new saveAgencyQrCodeBO();
        this.fileName = null;
        document.getElementById('openQRModal').click();
    }

    closeDeleteModal()
    {
        document.getElementById('openDelete').click();
    }
    public ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
